import { type ReactNode } from "react";
import { cn } from "@/lib/utils";

type TrustBadgeProps = {
  icon: ReactNode;
  label: ReactNode;
  className?: string;
};

const TrustBadge = ({ icon, label, className }: TrustBadgeProps) => {
  return (
    <div className={cn("inline-flex items-center", className)}>
      {icon}
      {label}
    </div>
  );
};

export default TrustBadge;
